import { PATHWAY } from "@/constants/testIds";
import { OPERATIONAL_MISSION } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

export default function OperationalMission() {
  return (
    <section
      id="mission"
      data-testid={PATHWAY.missionPanel}
      className="border-t hairline bg-[#0f0f0f]"
    >
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-24">
        <div className="grid gap-10 md:grid-cols-[260px_1fr] md:gap-16">
          <div>
            <SectionEyebrow>Current operational mission</SectionEyebrow>
            <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-neutral-50 sm:text-3xl">
              This is not software. It is an operational programme.
            </h2>
          </div>

          <div className="border hairline">
            <Row
              label="Objective"
              testId={PATHWAY.missionObjective}
              value={OPERATIONAL_MISSION.objective}
              wide
            />
            <Row
              label="Current pilot"
              testId={PATHWAY.missionPilot}
              value={OPERATIONAL_MISSION.currentPilot}
            />
            <div className="grid grid-cols-[160px_1fr] border-b hairline">
              <div className="border-r hairline px-5 py-4 font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
                Measured outcomes
              </div>
              <ul className="px-5 py-4">
                {OPERATIONAL_MISSION.outcomes.map((o, i) => (
                  <li
                    key={o}
                    data-testid={PATHWAY.missionOutcome(i + 1)}
                    className="border-b hairline py-2 text-[14px] leading-snug text-neutral-200 last:border-b-0"
                  >
                    {o}
                  </li>
                ))}
              </ul>
            </div>
            <div
              className="grid grid-cols-[160px_1fr]"
              data-testid={PATHWAY.missionStage}
            >
              <div className="border-r hairline px-5 py-4 font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
                Current stage
              </div>
              <div className="flex items-center gap-3 px-5 py-4">
                <span className="font-mono text-base text-amber-500">✓</span>
                <span className="text-[14px] text-neutral-100">
                  {OPERATIONAL_MISSION.currentStage}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Row({ label, value, testId, wide }) {
  return (
    <div className="grid grid-cols-[160px_1fr] border-b hairline">
      <div className="border-r hairline px-5 py-4 font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
        {label}
      </div>
      <div
        data-testid={testId}
        className={`px-5 py-4 ${
          wide ? "text-[15px]" : "font-serif text-xl"
        } leading-snug text-neutral-100`}
      >
        {value}
      </div>
    </div>
  );
}
